import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/services/payAll/store/payAllSlice/initialState.ts'
import { PayAllService } from '@/modules/services/payAll/types/PayAllService.ts'

const payAllSlice = createSlice({
  name: 'payAll',
  initialState,
  reducers: {
    setPayAllFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setEditService: (state, action: PayloadAction<PayAllService | null>) => {
      state.editService = action.payload
    },
    reset: () => initialState
  }
})

export const payAllActions = payAllSlice.actions
export const { reducer: payAllReducer } = payAllSlice
